var map = {
	"./bh-ico-active.svg": 1773,
	"./bh-ico.svg": 1774,
	"./bonus-ico-active.svg": 1775,
	"./bonus-ico.svg": 1776,
	"./deposit-ico.svg": 1777,
	"./deposit-ico.webp": 1778,
	"./edit-icon.svg": 1779,
	"./fb-ico.svg": 1780,
	"./instant-rebate-ico-active.svg": 1781,
	"./instant-rebate-ico.svg": 1782,
	"./mall-ico-active.svg": 1783,
	"./mall-ico.svg": 1784,
	"./msg-ico-active.svg": 1785,
	"./msg-ico.svg": 1786,
	"./pi-ico-active.svg": 1787,
	"./pi-ico.svg": 1788,
	"./rf-ico-active.svg": 1789,
	"./rf-ico.svg": 1790,
	"./rh-ico-active.svg": 1791,
	"./rh-ico.svg": 1792,
	"./th-ico-active.svg": 1793,
	"./th-ico.svg": 1794,
	"./vip-ico-active.svg": 1795,
	"./vip-ico.svg": 1796,
	"./withdrawal-ico.svg": 1797,
	"./withdrawal-ico.webp": 1798,
	"./wl-ico-active.svg": 1799,
	"./wl-ico.svg": 1800
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 472;